module.exports = __webpack_public_path__ + "static/media/g2tlogo.44fda24e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Application/Header/Assets/g2tlogo.svg
// module id = 919
// module chunks = 0